export const SALES_CHANNELS_BASE_PATH = '/sales-channels';

export const SALES_CHANNELS_ROUTES = {
  salesChannels: SALES_CHANNELS_BASE_PATH,
  salesChannelsApps: `${SALES_CHANNELS_BASE_PATH}/apps`,
  marketplacesApps: `${SALES_CHANNELS_BASE_PATH}/marketplaces`,
};
